export const init = () => {
  const $pricingSection = $.fn.findAnyInDocument('.c-pricing-table[data-type=pricing]');
  const $packagesSection = $.fn.findAnyInDocument('.c-pricing-table[data-type=packages]');

  if ($pricingSection.length === 1) {
    window.__PricingTableComponent = App.components.room_pricing_table(
      $pricingSection,
      'pricing',
      {
        onRowClick($el) {
          $.publish('room_page_interaction', {
            section: 'prices',
            element: 'weekday',
            element_value: $el.data('dayOfWeek'),
            interaction: 'click',
          });
        },
      },
    );
  }

  if ($packagesSection.length === 1) {
    window.__PackagesTableComponent = App.components.room_pricing_table(
      $packagesSection,
      'packages',
      {
        onRowClick($el) {
          $.publish('room_page_interaction', {
            section: 'event_offers',
            element: 'event_offer',
            element_value: $el.find('.c-pricing-table__row--header .c-pricing-table__item--package').text().trim(),
            interaction: 'click',
          });
        },
      },
    );
  }
};
